import { useEffect, useRef, useState } from 'react';

export const POLL_INTERVAL = 15000;

/**
 * Appelle `fn` immédiatement puis toutes les `interval` ms, uniquement quand
 * l'onglet est visible (et aussitôt que l'on y revient). Renvoie l'heure du
 * dernier rafraîchissement réussi.
 */
const usePolling = (fn, interval = POLL_INTERVAL, deps = []) => {
  const fnRef = useRef(fn);
  const [lastUpdate, setLastUpdate] = useState(null);
  fnRef.current = fn;

  useEffect(() => {
    let cancelled = false;
    let timer = null;

    const tick = async () => {
      clearTimeout(timer);
      if (document.visibilityState === 'visible') {
        try {
          await fnRef.current();
          if (!cancelled) setLastUpdate(new Date());
        } catch {
          /* réessai au prochain cycle */
        }
      }
      if (!cancelled) timer = setTimeout(tick, interval);
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') tick();
    };

    tick();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [interval, ...deps]); // eslint-disable-line

  return lastUpdate;
};

export default usePolling;
